import { createSelector } from '@reduxjs/toolkit';

const getOrgs = (state) => state.organization?.organizations;
const getCurrentOrgId = (state) => state.auth?.currentOrg;

export const getCurrentOrg = createSelector( //eslint-disable-line
  [getOrgs, getCurrentOrgId], (orgs, currentOrgId) => {
    if (orgs && currentOrgId) return orgs[currentOrgId];

    return null;
  },
);
